import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  loadingNotifications: false,
};

const userNotificationsSlice = createSlice({
  name: "userNotifications",
  initialState,
  reducers: {
    loadingNotifications(state) {
      state.loadingNotifications = true;
    },
    loadingNotificationsDone(state) {
      state.loadingNotifications = false;
    },
    setNotifications(state, action) {
      state.notifications = action.payload;
    },
  },
});
export const {
  loadingNotifications,
  loadingNotificationsDone,
  setNotifications,
} = userNotificationsSlice.actions;

export default userNotificationsSlice.reducer;
